import { c as _c } from "react/compiler-runtime";
import { ForwardedRef, PropsWithChildren, ReactElement } from 'react';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { scrollInline, scrollInlineMeasure, scrollInlineContent, scrollInlineMasks, scrollInlineNegativePadding, notOverflowingCSS, scrollInlineContainer } from './ScrollInline.css';
import { translateInline } from '@/globals/translate/translateInline';
import { focusWrapperPseudo } from '@/uiPrimitives/base/focus.css';
export const scrollInlineTranslations = {
  'Scroll left in previous scroll area': translateInline({
    en: 'Scroll the figure left',
    nl: 'Scroll het figuur naar links'
  }),
  'Scroll right in previous scroll area': translateInline({
    en: 'Scroll the figure right',
    nl: 'Scroll het figuur naar rechts'
  })
} as const;
export const ScrollInline = t0 => {
  const $ = _c(27);
  const {
    children,
    className,
    scrollAreaClassName,
    measureBeforeSlot,
    measureAfterSlot,
    mask,
    notOverflowing,
    scrollbarWidth,
    ref
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classes(className, scrollInlineContainer);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = scrollInlineNegativePadding[scrollbarWidth];
  let t3;
  if ($[2] !== t2) {
    t3 = classes(focusWrapperPseudo, t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = notOverflowing && notOverflowingCSS;
  const t5 = scrollInline[scrollbarWidth];
  const t6 = mask != null && scrollInlineMasks[mask];
  let t7;
  if ($[4] !== scrollAreaClassName || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = classes(t4, t5, t6, scrollAreaClassName);
    $[4] = scrollAreaClassName;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classes(scrollInlineMeasure);
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = classes(scrollInlineContent);
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== children) {
    t10 = <div className={t9}>{children}</div>;
    $[11] = children;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== measureAfterSlot || $[14] !== measureBeforeSlot || $[15] !== t10) {
    t11 = <div className={t8}>{measureBeforeSlot}{t10}{measureAfterSlot}</div>;
    $[13] = measureAfterSlot;
    $[14] = measureBeforeSlot;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== ref || $[18] !== t11 || $[19] !== t7) {
    t12 = <div ref={ref} className={t7} tabIndex={0}>{t11}</div>;
    $[17] = ref;
    $[18] = t11;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t3) {
    t13 = <div className={t3}>{t12}</div>;
    $[21] = t12;
    $[22] = t3;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t1 || $[25] !== t13) {
    t14 = <div className={t1}>{t13}</div>;
    $[24] = t1;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};
export const scrollLeft = (scrollAreaElement: HTMLDivElement, scrollRatio: number) => {
  const scrollDelta = scrollRatio * scrollAreaElement.clientWidth;

  // scrollBy has janky behaviour on iOS Safari
  scrollAreaElement.scrollTo({
    left: scrollAreaElement.scrollLeft - scrollDelta,
    behavior: 'smooth'
  });
};
export const scrollRight = (scrollAreaElement: HTMLDivElement, scrollRatio: number) => {
  const scrollDelta = scrollRatio * scrollAreaElement.clientWidth;

  // scrollBy has janky behaviour on iOS Safari
  scrollAreaElement.scrollTo({
    left: scrollAreaElement.scrollLeft + scrollDelta,
    behavior: 'smooth'
  });
};